"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GenericInputStyles_1 = require("../../../../common/components/genericInput/GenericInputStyles");
var TextField_1 = require("@material-ui/core/TextField");
var Typography_1 = require("@material-ui/core/Typography");
var InputLabel_1 = require("@material-ui/core/InputLabel");
var Box_1 = require("@material-ui/core/Box");
var TextareaInputStyles_1 = require("./TextareaInputStyles");
var TextareaInput = function (_a) {
    var formData = _a.formData;
    var label = formData.label, required = formData.required, id = formData.id, onChange = formData.onChange, value = formData.value, rawErrors = formData.rawErrors, _b = formData.options, inputLabel = _b.inputLabel, rows = _b.rows, placeholder = formData.placeholder;
    var styles = TextareaInputStyles_1.default();
    var genericInputStyle = GenericInputStyles_1.default();
    var currentError = react_1.useMemo(function () { var _a; return ((_a = rawErrors) === null || _a === void 0 ? void 0 : _a.length) > 0 && rawErrors[0]; }, [rawErrors]);
    var handleChange = react_1.useCallback(function (e) {
        onChange(e.target.value);
    }, [value]);
    return (<Box_1.default>
      {inputLabel && (<Box_1.default display={'flex'}>
          <Typography_1.default component={'span'} variant={'subtitle1'}>
            <InputLabel_1.default htmlFor={id} required={required} className={genericInputStyle.label} data-test={"textarea_input:label:" + id}>
              {label}
            </InputLabel_1.default>
          </Typography_1.default>
        </Box_1.default>)}
      <TextField_1.default data-test={"textarea_input:" + id} id={id} variant={'outlined'} value={(value !== null && value !== void 0 ? value : '')} multiline error={!!currentError} onChange={handleChange} rows={rows} fullWidth placeholder={placeholder} helperText={currentError && (<Typography_1.default component={'span'} className={genericInputStyle.errorText} data-test={"textarea_input:error:" + id}>
              {currentError}
            </Typography_1.default>)} InputProps={{
        classes: {
            root: styles.root,
            focused: genericInputStyle.focused,
            error: genericInputStyle.inputError,
            notchedOutline: genericInputStyle.notchedOutline,
        },
    }} FormHelperTextProps={{
        classes: {
            root: genericInputStyle.helperTextError,
        },
    }}/>
    </Box_1.default>);
};
exports.default = TextareaInput;
